import { DEBUG_EVENT } from '../actions/debug';

export const initialState = {
  debugEvents: []
};

export const debugLogsReducer = (state = initialState, { payload = {}, type }) => {
  switch (type) {
    case DEBUG_EVENT:
      const nextDebugEvents = [...state.debugEvents, { ...payload }];

      return {
        ...state,
        debugEvents: nextDebugEvents.slice(-30)
      };
    default:
      return state;
  }
};
